import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { connect, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import defaultImage from "../../../assets/images/default.jpg";
import { usePermission } from "../../../hooks/usePermission";
import { warningAccept } from "../../../util/Alert";
import { colors } from "../../../util/SkeletonColor";
import ImageSliderModal from "../../extra/ImageSliderModal";
import Pagination from "../../extra/Pagination";
import Searching from "../../extra/Searching";
import Table from "../../extra/Table";
import ToggleSwitch from "../../extra/ToggleSwitch";
import {
  acceptSellerRequest,
  getSellerRequest,
} from "../../store/sellerRequest/sellerRequest.action";

const Section = ({ title, children }) => (
  <div style={{
    border: "1px solid #eee",
    borderRadius: 8,
    padding: 10,
    marginTop: 12,
    fontSize: 12,
    background: "#fafafa"
  }}>
    <div style={{
      fontWeight: 600,
      marginBottom: 6,
      color: "#e91e63",
      fontSize: 12
    }}>
      {title}
    </div>
    <div style={{ lineHeight: 1.4 }}>
      {children}
    </div>
  </div>
);


const SellerRequest = (props) => {
  const { can } = usePermission();
  const canEdit = can("Seller", "Edit");



  const [page, setPage] = useState(0);
  const [data, setData] = useState([]);

  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  // Modal state for image slider
  const [showImageModal, setShowImageModal] = useState(false);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [selectedRowImages, setSelectedRowImages] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openSellerModal, setOpenSellerModal] = useState(false);
  const [selectedSeller, setSelectedSeller] = useState(null);



  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { sellerRequest } = useSelector((state) => state.sellerRequest);


  useEffect(() => {
    dispatch(getSellerRequest());
  }, [dispatch]);

  useEffect(() => {
    setData(sellerRequest);
  }, [sellerRequest]);

  // pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  const handleClick = (id) => {


    const data = warningAccept();
    data
      .then((isDeleted) => {
        if (isDeleted) {
          dispatch(acceptSellerRequest(id));
        }
      })
      .catch((err) => console.log(err));
  };

  // searching
  const handleFilterData = (filteredData) => {
    if (typeof filteredData === "string") {
      setSearch(filteredData);
    } else {
      setData(filteredData);
    }
  };

  const handleEdit = (id) => {

    navigate("/admin/sellerRequestEdit", {
      state: id,
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  const handleOpenSellerModal = (seller) => {
    setSelectedSeller(seller);
    setOpenSellerModal(true);
  };

  const handleCloseSellerModal = () => {
    setOpenSellerModal(false);
    setSelectedSeller(null);
  };


  const mapData = [
    {
      Header: "No",
      width: "20px",
      Cell: ({ index }) => <span className="text-white fw-normal">{page * rowsPerPage + parseInt(index) + 1}</span>,
    },
    {
      Header: "Seller",
      body: "seller",
      Cell: ({ row }) => {
        const seller = row;
        const imageUrl = row?.image || defaultImage;

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {loading ? (
              <Skeleton
                height={40}
                width={40}
                style={{ borderRadius: "50%" }}
                baseColor={colors?.baseColor}
                highlightColor={colors?.highlightColor}
              />
            ) : (
              <img
                src={imageUrl}
                height={45}
                width={45}
                alt="seller"
                style={{ borderRadius: "50%", objectFit: "cover" }}
                onClick={() => handleOpenSellerModal(seller)}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultImage;
                }}
              />
            )}

            <span className="text-white text-capitalize">
              {[seller?.firstName, seller?.lastName]
                .filter(Boolean)
                .join(" ") || "-"}
            </span>
          </div>
        );
      },
    }
    ,

    {
      Header: "Documents",
      body: "documents",
      Cell: ({ row }) => {
        const documents = [
          { url: row?.addressProof, label: "Address Proof" },
          { url: row?.govId, label: "Gov ID" },
          { url: row?.registrationCert, label: "Registration Cert" }
        ].filter(doc => doc.url);

        return (
          <>
            {loading ? (
              <div className="d-flex gap-2 align-items-center justify-content-evenly">
                {[1, 2, 3].map((_, idx) => (
                  <Skeleton
                    key={idx}
                    height={40}
                    width={40}
                    style={{ borderRadius: "10px" }}
                    baseColor={colors?.baseColor}
                    highlightColor={colors?.highlightColor}
                  />
                ))}
              </div>
            ) : documents.length > 0 ? (
              <div className="d-flex gap-2 align-items-center justify-content-evenly">
                {documents.map((doc, index) => (
                  <img
                    key={index}
                    src={doc.url}
                    style={{
                      borderRadius: "8px",
                      cursor: "pointer",
                      border: "1px solid #ddd"
                    }}
                    height={40}
                    width={40}
                    alt={doc.label}
                    crossOrigin="anonymous"
                    title={doc.label}
                    onClick={() => {
                      const allImages = documents.map(d => d.url);
                      setSelectedRowImages(allImages);
                      setActiveImageIndex(index);
                      setShowImageModal(true);
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = defaultImage;
                    }}
                  />
                ))}
              </div>
            ) : (
              <span className="text-white">-</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Business Name",
      body: "businessName",
      Cell: ({ row }) => (
        <span className="mb-0 text-white">
          {row?.businessName || "-"}
        </span>
      ),
    },


    {
      Header: "Gender",
      body: "gender",
      Cell: ({ row }) => (
        // <span className="mb-0 text-white">{row?.gender || "-"}</span>
        <span className="mb-0 text-white" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}>
          {row?.gender?.toLowerCase() === "male" && (
            <i className="material-icons text-primary">male</i>
          )}

          {row?.gender?.toLowerCase() === "female" && (
            <i className="material-icons text-danger">female</i>
          )}

          {row?.gender || "-"}
        </span>

      ),
    },
    {
      Header: "Country",
      body: "country",
      Cell: ({ row }) => <span className="text-white">{row?.address?.country || "-"}</span>,
    },

    ...(canEdit ? [
      {
        Header: "Accept",
        body: "isAccepted",
        Cell: ({ row }) => (
          <div className="">
            <ToggleSwitch
              value={row?.isAccepted}
              onClick={() => handleClick(row._id)}
            />
          </div>
        ),
      }
    ] : []),

    {
      Header: "Created Date",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className="text-white">{dayjs(row.createdAt).format("DD MMM YYYY")}</span>
      ),
    },

  ];
  return (
    <>
      <div className="mainSellerTable">

        <Modal open={openSellerModal} onClose={handleCloseSellerModal}>
          <Box sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "60%",
            maxWidth: "650px",
            bgcolor: "#fff",
            borderRadius: "14px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
            p: 2,
            maxHeight: "85vh",
            overflowY: "auto"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h3 style={{ fontSize: 18 }}>Seller Details</h3>

              <div
                onClick={handleCloseSellerModal}
                style={{
                  cursor: "pointer",
                  border: "1.5px solid #f06292",
                  borderRadius: "50%",
                  height: 24,
                  width: 24,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#f06292",
                  fontSize: 13,
                  fontWeight: "bold"
                }}
              >✕</div>
            </div>

            {selectedSeller && (
              <>
                {/* PROFILE */}
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  border: "1px solid #eee",
                  padding: 12,
                  borderRadius: 10,
                  marginTop: 15
                }}>
                  <img
                    src={selectedSeller.image || defaultImage}
                    height={55}
                    width={55}
                    style={{ borderRadius: "50%", objectFit: "cover" }}
                  />

                  <div>
                    <h4 style={{ margin: 0, fontSize: 15 }}>
                      {selectedSeller.firstName} {selectedSeller.lastName}
                    </h4>
                    <span style={{
                      background: "#e91e63",
                      color: "#fff",
                      padding: "3px 12px",
                      borderRadius: 20,
                      fontSize: 10
                    }}>
                      Seller
                    </span>
                  </div>
                </div>

                {/* DETAILS */}
                <div style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 12,
                  marginTop: 15
                }}>

                  <Section title="Personal Info">
                    Email: {selectedSeller.email}<br />
                    Mobile: {selectedSeller.mobileNumber}<br />
                    Gender: {selectedSeller.gender || "N/A"}
                  </Section>

                  <Section title="Business">
                    Name: {selectedSeller.businessName}<br />
                    Tag: {selectedSeller.businessTag || "N/A"}
                  </Section>

                  <Section title="Address">
                    City: {selectedSeller.address?.city}<br />
                    State: {selectedSeller.address?.state}<br />
                    Country: {selectedSeller.address?.country}
                  </Section>

                  <Section title="Account">
                    ID: {selectedSeller._id}<br />
                    Joined: {dayjs(selectedSeller.createdAt).format("DD MMM YYYY")}
                  </Section>

                </div>
              </>
            )}
          </Box>
        </Modal>

        <div className="sellerTable">

          <div className="col-12 headname">Pending Seller </div>
          <div className="sellerMain">
            <div className="tableMain mt-2">
              <div className="sellerHeader primeHeader">
                <div className="row">
                  <div className="col-2"></div>

                  <div className="col-10">
                    <Searching
                      type={"client"}
                      data={sellerRequest}
                      setData={setData}
                      onFilterData={handleFilterData}
                      serverSearching={handleFilterData}
                    />
                  </div>
                </div>
              </div>
              <Table
                data={data}
                mapData={mapData}
                PerPage={rowsPerPage}
                Page={page}
                type={"client"}
              />
              <Pagination
                component="div"
                count={sellerRequest?.length}
                serverPage={page}
                type={"client"}
                onPageChange={handleChangePage}
                serverPerPage={rowsPerPage}
                totalData={sellerRequest?.length}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </div>
          <div className="sellerFooter primeFooter"></div>
        </div>
      </div>

      <ImageSliderModal
        isOpen={showImageModal}
        onClose={() => setShowImageModal(false)}
        images={selectedRowImages}
        initialSlide={activeImageIndex}
      />

    </>
  );
};

export default connect(null, { getSellerRequest, acceptSellerRequest })(
  SellerRequest
);
// export default Seller;
